import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="border-t border-border/50 mt-16">
      <div className="container py-10 max-w-3xl mx-auto text-center space-y-4">
        {/* Brand */}
        <p className="text-sm text-foreground">
          © 2026 PharmaRadar. Real-time pharmaceutical and biotech intelligence.
        </p>

        {/* Methodology + legal */}
        <p className="text-xs text-muted-foreground leading-relaxed">
          PharmaRadar aggregates publicly available information and generates AI-driven analysis
          grounded in official sources (SEC, FDA, ClinicalTrials.gov, company press releases).
          It does not reproduce copyrighted news content. News media are used solely for signal detection.
        </p>

        {/* Links */}
        <div className="flex items-center justify-center flex-wrap gap-x-3 gap-y-1 text-xs text-muted-foreground">
          <Link to="/terms" className="hover:text-foreground transition-colors">Terms of Service</Link>
          <span className="text-border">·</span>
          <Link to="/terms" className="hover:text-foreground transition-colors">Privacy Policy</Link>
          <span className="text-border">·</span>
          <Link to="/copyright" className="hover:text-foreground transition-colors">Copyright Policy</Link>
          <span className="text-border">·</span>
          <Link to="/dmca" className="hover:text-foreground transition-colors">DMCA</Link>
        </div>

        {/* Company */}
        <p className="text-[11px] text-muted-foreground/70 tracking-wide">LuTra Studio LLC</p>
      </div>
    </footer>
  );
}
